import {HOST, registerModel} from '@/utils/base';

export default [
    {
        path: HOST + 'froum',
        component: () => import('@/layouts/ImsLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            //弹框编辑
            {
                path: 'popup/add',
                component: () => import('@/routes/froum/popup/add'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 经历
                path: 'undergo/info',
                component: () => import('@/routes/froum/undergo/info'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 经历
                path: 'ask/info',
                component: () => import('@/routes/froum/ask/info'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // topic
                path: 'topic/info',
                component: () => import('@/routes/froum/topic/info'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 用户
                path: 'member/list',
                component: () => import('@/routes/froum/member/list'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 经历
                path: 'undergo/list',
                component: () => import('@/routes/froum/undergo/list'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 问答
                path: 'ask/list',
                component: () => import('@/routes/froum/ask/list'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 话题
                path: 'topic/list',
                component: () => import('@/routes/froum/topic/list'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 举报
                path: 'report/list',
                component: () => import('@/routes/froum/report/list'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 广场
                path: 'ground/list',
                component: () => import('@/routes/froum/ground/list'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 广场详情
                path: 'ground/info',
                component: () => import('@/routes/froum/ground/info'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 游企
                path: 'game/list',
                component: () => import('@/routes/froum/game/list'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 游戏公司列表（4个子管理按钮）
                path: 'game/corpList',
                component: () => import('@/routes/froum/game/corpList'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 游企信息（编年史/项目/联系人 Tab 管理）
                path: 'game/corpInfo',
                component: () => import('@/routes/froum/game/corpInfo'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 项目管理
                path: 'game/corpProject',
                component: () => import('@/routes/froum/game/corpProject'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 项目扩展（团队成员/合作供应商管理）
                path: 'game/projectInfo',
                component: () => import('@/routes/froum/game/projectInfo'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 投票删帖管理
                path: 'delvote/list',
                component: () => import('@/routes/froum/delvote/list'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 积分管理
                path: 'points/list',
                component: () => import('@/routes/froum/points/list'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 薪酬待遇管理
                path: 'salary/list',
                component: () => import('@/routes/froum/salary/list'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 简历管理
                path: 'resume/list',
                component: () => import('@/routes/froum/resume/list'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 岗位管理
                path: 'recruit/list',
                component: () => import('@/routes/froum/recruit/list'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
        ],
    },
];



// WEBPACK FOOTER //
// ./src/common/froum_router.js